import React, { Component } from 'react'
import PropTypes from 'prop-types'

import CustomDate from '../../../../../../../../../../components/CustomDate'

import './style.scss'

export default class Degrees extends Component {
    static propTypes = {
        data: PropTypes.array,
        legend: PropTypes.array,
    }

    render() {
        const { data, legend } = this.props

        return (
            <div className={'bisnode-scoring-degrees'}>
                <div className={'scoring-columns-wrapper'}>
                    {data.map((column, index) => (
                        <div className={'scoring-column'} key={`scoring-column-${index}`}>
                            <div className={'date-container'}>
                                {column?.startDate?.value && (
                                    <CustomDate
                                        date={column?.startDate?.value}
                                        precision={column?.startDate?.precision}
                                    />
                                )}
                                {column?.startDate?.value && column?.endDate?.value && (
                                    <span style={{ padding: '0 4px' }}>{'-'}</span>
                                )}
                                {column?.endDate?.value && (
                                    <CustomDate date={column?.endDate?.value} precision={column?.endDate?.precision} />
                                )}
                            </div>
                            <div className={'value-container'}>
                                <div
                                    className={'scoring-text'}
                                    style={{ color: legend.find((x) => x?.code === column?.code)?.color || '#B3B3B3' }}
                                >
                                    {legend.find((x) => x?.code === column?.code)?.degree || 'N/A'}
                                </div>
                                <div className={'scoring-desc'}>{column?.description}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        )
    }
}
